
import { en } from "./en";

type Translation = typeof en;

export const pl: Translation = {
  common: {
    close: "Zamknij",
    copy: "Kopiuj",
    copied: "Skopiowano",
    news: "Wiadomości",
    more: "Więcej",
    success: "Sukces",
    failed: "Niepowodzenie",
    page: "Strona",
    of: "z",
    loading: "Ładowanie...",
    error: "Błąd",
    search: "Szukaj",
    reset: "Resetuj",
    filter: "Filtruj",
    details: "Szczegóły",
    no_results: "Nie znaleziono wyników",
    no_description: "Brak dostępnego opisu",
    back: "Wróć",
    deselect_all: 'Odznacz wszystko',
    select_all: 'Zaznacz wszystko',
    yes: 'Tak',
    no: 'Nie',
  },
  navbar: {
    news: "Aktualności",
    leaks: "Wycieki",
    cve: "CVE",
    ransomware: "Ransomware",
    eol: "EOL",
    releases: 'Wydania',
    dashboard: 'Dashboard',
    scan: 'Skan',
  },
  cities: {
    "Los Angeles": "Los Angeles",
    "Zurich": "Zurych",
    "Viana": "Viana",
    "Moscow": "Moskwa",
    "Falkenstein": "Falkenstein",
    "Vienna": "Wiedeń",
    "Sofia": "Sofia",
    "Paris": "Paryż",
    "Amsterdam": "Amsterdam",
    "London": "Londyn",
    "London, UK": "Londyn, UK",
    "Singapore": "Singapur",
    "New York": "Nowy Jork",
    "Dallas": "Dallas",
    "Miami": "Miami",
    "Frankfurt": "Frankfurt",
    "Warsaw": "Warszawa",
    "Bengaluru": "Bengaluru",
    "Delhi": "Delhi",
    "Hyderabad": "Hyderabad",
    "Kolkata": "Kalkuta",
    "Mumbai": "Mumbaj",
    "Jakarta": "Dżakarta",
    "Esfahan": "Isfahan",
    "Karaj": "Karadż",
    "Mashhad": "Meszhed",
    "Shiraz": "Sziraz",
    "Tehran": "Teheran",
    "Netanya": "Netanja",
    "Tel Aviv": "Tel Awiw",
    "Milan": "Mediolan",
    "Tokyo": "Tokio",
    "Sao Paulo": "São Paulo",
    "Vancouver": "Vancouver",
    "Ceske Budejovice": "Czeskie Budziejowice",
    "Helsinki": "Helsinki",
    "Roubaix": "Roubaix",
    "Nuremberg": "Norymberga",
    "Hong Kong": "Hongkong",
    "Nyiregyhaza": "Nyiregyhaza",
    "Seoul": "Seul",
    "Karaganda": "Karaganda",
    "Vilnius": "Wilno",
    "Chisinau": "Kiszyniów",
    "Meppel": "Meppel",
    "Poznan": "Poznań",
    "Belgrade": "Belgrad",
    "Saint Petersburg": "Sankt Petersburg",
    "Ekaterinburg": "Jekaterynburg",
    "Tallberg": "Tallberg",
    "Maribor": "Maribor",
    "Gebze": "Gebze",
    "Khmelnytskyi": "Chmielnicki",
    "Kyiv": "Kijów",
    "SpaceX Starlink": "SpaceX Starlink",
    "Coventry": "Coventry",
    "Atlanta": "Atlanta",
    "Ho Chi Minh City": "Ho Chi Minh",
    "C.Budejovice": "Czeskie Budziejowice",
    "Barcelona": "Barcelona",
    "Madrid": "Madryt"
  },

  index: {
    title: "CyberMonit - Bądź na bieżąco z zagrożeniami cyberbezpieczeństwa",
    description: "CyberMonit to platforma do monitorowania i analizowania zagrożeń cyberbezpieczeństwa. Zbieramy dane z różnych źródeł, aby dostarczyć Ci najbardziej aktualne informacje o wyciekach, lukami, ransomware i końcu życia oprogramowania.",
    latest_news: "Najnowsze wiadomości",
    leaks: "Wycieki",
    cve: "CVE",
    ransomware: "Ransomware",
    eol: "EOL",
  },
  news: {
    title: "Najnowsze Aktualności",
    sources: "Źródła Wiadomości",
    loading: "Ładowanie wiadomości...",
    error: "Błąd ładowania wiadomości",
    readMore: "Czytaj więcej",
    page: "Strona",
    of: "z",
    pageTitle: "Najnowsze Informacje z Cyberbezpieczeństwa",
    read_more: "Czytaj więcej",
  },
  leaks: {
    title: "Najnowsze wycieki danych",
    subtitle: "Monitoruj najnowsze wycieki danych i naruszenia bezpieczeństwa.",
    searchPlaceholder: "Szukaj wycieków...",
    noLeaks: "Nie znaleziono wycieków.",
    domain: "Domena",
    no_domain: "Nieznane źródło",
    dataTypes: "Rodzaje danych",
    details: 'Zobacz szczegóły',
    breach_stats: 'Statystyki wycieku',
    records: 'Rekordów',
    data_types: 'Typy danych',
    description: 'Opis',
    close: "Zamknij",
    loading: "Ładowanie wycieków...",
    error: "Błąd ładowania wycieków",
    searchResults: "Znaleziono {count} wyników",
    noResults: "Nie znaleziono wycieków spełniających kryteria",
    resetFilters: "Resetuj filtry",
    pageTitle: "Baza Wycieków Danych",
    verified_leak: "ZWERYFIKOWANY WYCIEK",
    verified_source: "Zweryfikowane Źródło",
  },
  cve: {
    title: "Baza Danych CVE",
    subtitle: "Przeszukuj bazę podatności CVE",
    searchPlaceholder: "Szukaj CVE (np. CVE-2023-4863)",
    clearSearch: "Wyczyść wyszukiwanie",
    searching_progress: "Wyszukiwanie w toku...",
    noSearchResults: "Brak wyników wyszukiwania",
    searchResults: "Znaleziono {count} wyników",
    year_selector: "Rok",
    year_selector_description: "Wybierz rok CVE",
    filter: "Filtr Ważności",
    'filter.critical': "Krytyczne",
    'filter.high': "Wysokie",
    'filter.medium': "Średnie",
    'filter.low': "Niskie",
    current_year: "Bieżący Rok",
    details: "Zobacz szczegóły",
    score: "Ocena",
    close: "Zamknij",
    search_all_years: "Przeszukaj Wszystkie Lata",
    loading_year: "Ładowanie danych z roku {year}...",
    more_years: "Więcej Lat",
    show_stats: "Pokaż Statystyki",
    hide_stats: "Ukryj Statystyki",
    severity: {
      critical: "KRYTYCZNY",
      high: "WYSOKI",
      medium: "ŚREDNI",
      low: "NISKI",
      unknown: "NIEZNANY",
    },
    status: {
      published: "OPUBLIKOWANE",
      rejected: "ODRZUCONE",
      modified: "ZMODYFIKOWANE",
      analyzed: "PRZEANALIZOWANE",
      waiting: "OCZEKUJĄCE",
      unknown: "NIEZNANY",
    },
    cpe: {
      vendor: "Producent",
      product: "Produkt",
      version: "Wersja",
      affected_versions: "Podatne wersje",
    },
  },
  ransomware: {
    title: "Ataki Ransomware",
    description: "Bądź na bieżąco z najnowszymi atakami ransomware i chroń swoje dane.",
    subtitle: "Śledź i monitoruj najnowsze ataki ransomware w różnych krajach i sektorach",
    countryFilter: "Filtr Krajów",
    searchPlaceholder: "Szukaj ataków...",
    showFilter: "Pokaż Filtry",
    details: "Zobacz szczegóły",
    close: "Zamknij",
    noSearchResults: "Nie znaleziono ataków ransomware",
    resetFilters: "Resetuj Filtry",
    filterInstructions: "Wybierz kraje, aby filtrować ataki",
    selectAll: "Zaznacz Wszystkie",
    deselectAll: "Odznacz Wszystkie",
    other: "Inne",
    hideFilter: "Ukryj Filtry",
    searchResults: "Znaleziono {count} wyników",
    noFilteredResults: "Żadne ataki nie pasują do obecnych filtrów",
    showingCountries: "Pokazywanie ataków z {count} krajów",
    loading: "Ładowanie danych ransomware...",
    showingResultsFor: "Pokazywanie wyników dla",
    no_attacks_recorded: "Nie odnotowano ataków ransomware",
    top_targets: "Główne Cele",
    attacks: "Ataki",
    victims: "Ofiary",
  },
  eol: {
    title: "Oprogramowanie z zakończonym wsparciem",
    subtitle: "Śledź oprogramowanie, które osiągnęło koniec życia i może stanowić zagrożenie dla bezpieczeństwa",
    description: "Śledź oprogramowanie, które osiągnęło koniec życia i może stanowić zagrożenie dla bezpieczeństwa.",
    searchPlaceholder: "Szukaj oprogramowania...",
    details: "Zobacz szczegóły",
    daysRemaining: "Pozostało dni",
    expired: "Wygasło",
    lts: "LTS",
    no: "Nie",
    latestReleaseDate: "Data najnowszego wydania",
    releaseDate: "Data wydania",
    eolDate: "Data końca wsparcia",
    latestVersion: "Najnowsza wersja",
    pageTitle: "Śledzenie Oprogramowania z Zakończonym Wsparciem",
    all: "Wszystkie",
    sortName: "Sortuj według Nazwy",
    clearFilters: "Wyczyść Filtry",
    loading: "Ładowanie danych EOL...",
    version: "Wersja",
    sortEOL: "Sortuj według daty EOL",
    searchResults: "Znaleziono {count} wyników",
    statusActive: "Aktywne",
    statusWarning: "Ostrzeżenie",
    statusExpired: "Wygasłe",
  },
  themeToggle: {
    light: "Jasny",
    dark: "Ciemny",
    system: "Systemowy",
  },
  languageToggle: {
    pl: 'Polski',
    en: 'Angielski',
    change: 'zmień język',
  },
  footer: {
    made_by: "Stworzone przez",
    source_code: "Kod źródłowy",
    rights: "Wszelkie prawa zastrzeżone",
  },
  releases: {
    title: 'Wydania Oprogramowania',
    description: 'Śledź najnowsze wydania i aktualizacje oprogramowania z Twoich ulubionych projektów.',
    search_placeholder: 'Szukaj projektów...',
    clear_search: 'Wyczyść wyszukiwanie',
    searching: 'Wyszukiwanie...',
    search_results: 'Znaleziono {count} wyników',
    no_results: 'Nie znaleziono projektów spełniających kryteria wyszukiwania',
    no_data: 'Brak dostępnych danych o wydaniach',
    error_title: 'Nie udało się załadować danych o wydaniach',
    error_description: 'Wystąpił błąd podczas ładowania danych o wydaniach. Spróbuj ponownie później.',
    error_toast: 'Nie udało się załadować danych o wydaniach',
    github_repository: 'Repozytorium Github',
    pageTitle: 'Najnowsze Wydania Oprogramowania',
    release_date: 'Wydano',
  },
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Kluczowe wskaźniki i statystyki cyberbezpieczeństwa z ostatnich {days} dni',
    pageTitle: 'Dashboard Cyberbezpieczeństwa',
    description: 'Zobacz kluczowe wskaźniki i statystyki cyberbezpieczeństwa z ostatnich 30 dni',
    ending_support: 'Kończące się wsparcie',
    data_leaks: 'Wycieki Danych',
    active_group: 'Najaktywniejsza Grupa Ransomware',
    ransomware_victims: 'Ofiary Ransomware',
    critical_vulnerabilities: 'Krytyczne Podatności',
    high_vulnerabilities: 'Wysokie Podatności',
    medium_vulnerabilities: 'Średnie Podatności',
    low_vulnerabilities: 'Niskie Podatności',
    last_days: 'Ostatnie {days} dni',
    most_attacked_country: 'Najczęściej atakowany kraj',
    latest_news: 'Najnowsze Wiadomości',
    recent_leaks: 'Ostatnie Wycieki Danych',
    critical_vulnerabilities_recent: 'Najnowsze Krytyczne Podatności',
    upcoming_eol: 'Oprogramowanie Wkrótce bez Wsparcia',
    latest_releases: 'Najnowsze Wydania',
    latest_ransomware: 'Najnowsze Ataki Ransomware',
    ransomware_recent: 'Najnowsze Ataki Ransomware', // Keep this for backward compatibility
    global_ransomware_activity: 'Globalna Aktywność Ransomware',
  },
  scan: {
    title: 'Pasywny Rekonesans',
    subtitle: 'Analizuj domenę bez alarmowania celu. Zbiera dane z rejestrów publicznych, DNS, archiwów i kanałów wywiadowczych o zagrożeniach.',
    input_placeholder: 'Wpisz domenę do skanowania...',
    button_scan: 'Rozpocznij skanowanie',
    button_scanning: 'Skanowanie...',
    started: 'Skanowanie rozpoczęte',
    recent_scans: 'Ostatnie skany',
    no_data: 'Brak wyników skanowania. Wpisz domenę, aby rozpocząć.',
    error_domain: 'Wprowadź poprawną domenę',
    loading_analyzing: 'Analizowanie celu...',
    map_title: 'Aktywne Węzły Monitorujące',
    score: 'Wynik',
    server_location: 'Lokalizacja Serwera',
    user_agent: 'User-Agent Skanera',
    review_reputation: 'Sprawdź reputację na VirusTotal',
    live_intelligence: 'Podgląd na żywo',
    preview_unavailable: 'Podgląd niedostępny',
    comprehensive_results: 'Kompleksowe Wyniki Skanowania',
    missing: 'Brakujący',
    present: 'Obecny',
    expires: 'Wygasa',
    created: 'Utworzono',
    domain_age: 'Wiek Domeny',
    latest_snapshot: 'Ostatnia Migawka',
    view_snapshot: 'Zobacz Migawkę',
    no_snapshots: 'Nie znaleziono historycznych migawek dla tego adresu URL w Wayback Machine.',

    security_headers: 'Nagłówki bezpieczeństwa',
    connection_stack: 'Specyfikacja stosu połączeń',
    protocol: 'Protokół',
    cipher_suite: 'Pakiet szyfrów',
    key_exchange: 'Wymiana kluczy',
    post_quantum: 'GOTOWY NA POST-QUANTUM',
    dns_email_security: 'Bezpieczeństwo DNS i Email',
    grade: 'Ocena',
    address_records: 'Rekordy adresowe',
    txt_records: 'Rekordy TXT i Polityki',
    server_location_title: 'Serwer i Lokalizacja',
    infrastructure: 'Infrastruktura',
    detected_technologies: 'Wykryte technologie',
    configuration: 'Konfiguracja SSL/TLS',
    common_name: 'Nazwa pospolita (CN)',
    issuer_org: 'Organizacja wystawcy',
    validity: 'Ważność',
    days: 'Dni',
    protocol_status: 'Protokół / Status',
    transparency_note: 'Uwaga: Dane pochodzą z dzienników Certificate Transparency (Pasywne).',

    // New keys
    server: 'Serwer',
    unknown: 'Nieznany',
    n_a: 'N/D',
    domain: 'Domena',
    no_signatures: 'Brak specyficznych sygnatur.',
    no_open_ports: 'Nie znaleziono otwartych portów',
    no_subdomains_transparency: 'Nie znaleziono subdomen w logach transparentności.',
    none: 'Brak',
    not_archived: 'Nie zarchiwizowano',
    header_hidden: 'Ukryty',
    standard_undetected: 'Standardowy / Niewykryty',
    rdap_limited: 'RDAP niedostępny dla tej domeny. Ograniczone dane.',
    no_txt_records: 'Nie znaleziono rekordów TXT.',


    status_transfer_prohibited: 'Status: transfer klienta zabroniony',
    internet_archive: 'Internet Archive',
    archived_found: 'Znaleziono zarchiwizowaną kopię',
    archive_seen: 'Archive.org widzi tę stronę od {year} roku (ok.)',
    source: 'Źródło',
    registrar: 'Rejestrator',
    status_label: 'Status',
    client_transfer_prohibited: 'transfer klienta zabroniony',
    safebrowsing_title: 'Google Safe Browsing',
    shodan_title: 'Shodan InternetDB',
    abuseipdb_title: 'Reputacja AbuseIPDB',
    urlhaus_title: 'Baza Malware URLhaus',
    open_ports: 'Otwarte Porty',
    vulnerabilities_title: 'Znane Podatności',
    hostnames: 'Nazwy Hostów',
    abuse_score: 'Wynik Abuse',
    clean: 'Nie Znaleziono Malware',
    urlhaus_clean_desc: 'Ten host nie figuruje w bazie URLhaus.',
    malicious_detected: 'Znaleziono Złośliwe Adresy',
    virustotal_title: 'Analiza VirusTotal',
    harmless: 'Bezpieczne',
    malicious: 'Złośliwe',
    suspicious: 'Podejrzane',
    undetected: 'Niewykryte',
    reputation: 'Reputacja',
    categories: 'Kategorie',
    last_analysis_date: 'Data Ostatniej Analizy',
    view_full_report: 'Zobacz pełny raport w VirusTotal',
    setup_required: 'Wymagana Konfiguracja',
    add_key_to_env: 'Dodaj {key} do .env',
    subdomains_title: 'Wykryte Subdomeny',
    discovered_subdomains: 'Unikalne Subdomeny',
    link_appears_safe: 'Ten link wydaje się bezpieczny',
    no_threats_detected: 'Skanery bezpieczeństwa nie wykryły zagrożeń',
    link_suspicious: 'Ten link może być podejrzany',

    // AbuseIPDB translations
    last_reported: 'Ostatnio zgłoszono',
    reports: 'Zgłoszenia',
    whitelist: 'Biała lista',

    // Safe Browsing translations
    safe_to_visit: 'Bezpieczna do odwiedzenia',
    no_threats_found: 'Google Safe Browsing nie znalazł żadnych zagrożeń',
    unsafe_website: 'Wykryto Niebezpieczną Stronę!',
    flagged_by_google: 'Ta strona jest oznaczona przez Google',
    threat_details: 'Szczegóły zagrożenia',

    // Shodan translations
    no_known_vulnerabilities: 'Nie zgłoszono znanych podatności',

    // WhatCMS Technology Detection
    technology_detection: 'Wykrywanie Technologii',
    cms_detected: 'Wykryty CMS',
    programming_language: 'Język Programowania',
    database: 'Baza Danych',
    web_server: 'Serwer WWW',
    wordpress_theme: 'Motyw WordPress',
    hosting_provider: 'Dostawca Hostingu',
    social_profiles: 'Profile Społecznościowe',
    landing_page_builder: 'Kreator Landing Page',
    no_technologies_detected: 'Nie wykryto technologii',
    theme_name: 'Nazwa motywu',
    theme_author: 'Autor',
    theme_version: 'Wersja',
    host_isp: 'ISP',
    ip_addresses: 'Adresy IP',
    some_warnings: 'Niektóre skanery zgłosiły potencjalne problemy',
    link_dangerous: 'Ten link jest potencjalnie niebezpieczny',
    threats_detected: 'Skanery wykryły zagrożenia',
    analyzing: 'Analizowanie...',
    gathering_data: 'Zbieranie danych bezpieczeństwa',
    passed: 'OK',
    warnings: 'ostrzeżeń',
    threats: 'zagrożeń',
    threat_intelligence: 'Analiza Zagrożeń',
    reputation_malware: 'Reputacja i Malware',
    server_network: 'Serwer i Sieć',
    location_ports: 'Lokalizacja i Porty',
    technical_details: 'Szczegóły Techniczne',
  },
  hibp: {
    email_checker_title: 'Sprawdzanie Wycieków Email',
    email_checker_desc: 'Sprawdź, czy Twój email pojawił się w wycieku danych',
    password_checker_title: 'Sprawdzanie Hasła',
    password_checker_desc: 'Sprawdź, czy Twoje hasło zostało ujawnione w wycieku',
    password_generator_title: 'Generator Hasła',
    password_generator_desc: 'Wygeneruj silne, bezpieczne hasło',
    enter_email: 'podaj.email@przykład.pl',
    enter_password: 'Wpisz hasło do sprawdzenia',
    check: 'Sprawdź',
    generate: 'Wygeneruj Hasło',
    invalid_email: 'Podaj prawidłowy adres email',
    api_key_missing: 'Klucz API HIBP nie jest skonfigurowany',
    check_failed: 'Nie udało się sprawdzić',
    no_breaches_found: 'Nie znaleziono wycieków!',
    email_not_in_database: 'Ten email nie znajduje się władnej znanej bazie wycieków.',
    breaches_found: 'Znaleziono w {count} wyciekach',
    change_passwords_recommendation: 'Rozważ zmianę hasła dla dotkniętych kont',
    accounts: 'kont',
    password_safe: 'Hasło bezpieczne',
    password_safe_desc: 'To hasło nie pojawiło się w znanych wyciekach',
    password_compromised: 'Znaleziono w {count} wyciekach',
    change_password_now: 'To hasło jest skompromitowane. Zmień je natychmiast!',
    security_note: 'Bezpiecznie: Twoje hasło nigdy nie jest wysyłane na nasze serwery. Używamy k-anonimowości, aby chronic Twoją prywatność.',
    password_copied: 'Hasło skopiowane do schowka',
    password_length: 'Długość hasła',
    character_types: 'Typy znaków',
    lowercase: 'Małe litery (a-z)',
    uppercase: 'Wielkie litery (A-Z)',
    numbers: 'Cyfry (0-9)',
    special: 'Znaki specjalne (!@#$...)',
    recommended_settings: 'Zalecane: 14+ znaków z wszystkimi typami znaków',
    security_tools: 'Narzędzia Bezpieczeństwa',
    security_tools_desc: 'Sprawdź bezpieczeństwo swojego emaila i hasła',
    password_strength: 'Siła hasła',
  },
};
